// Importing necessary color utilities
import {
  blackColor,
  whiteColor,
  hexToRgb,
} from "assets/jss/material-dashboard-react";

// Defining styles for card components
const cardStyle = {
  // General card styles
  card: {
    border: "0",
    marginBottom: "30px",
    marginTop: "30px",
    borderRadius: "6px",
    color: `rgba(${hexToRgb(blackColor)}, 0.87)`,
    background: whiteColor,
    width: "100%",
    boxShadow: `0 1px 4px 0 rgba(${hexToRgb(blackColor)}, 0.14)`,
    position: "relative",
    display: "flex",
    flexDirection: "column",
    minWidth: "0",
    wordWrap: "break-word",
    fontSize: ".875rem",
  },
  // Styles for plain cards (no background or shadow)
  cardPlain: {
    background: "transparent", // Transparent background
    boxShadow: "none", // No shadow
  },
  // Styles for profile cards
  cardProfile: {
    marginTop: "30px", // Top margin
    textAlign: "center", // Centered text
  },
  // Styles for chart cards
  cardChart: {
    "& p": {
      marginTop: "0px", // No top margin for paragraphs
      paddingTop: "0px", // No top padding for paragraphs
    },
  },
};

export default cardStyle;
